<template>
  <v-container fluid  elevation-3 @keyup="openDialog">
    <v-dialog
      persistent
      v-model="dialogEdit"
      lazy
      max-width="1500px"
    >
      <v-layout>
        <v-flex>
          <v-card>
            <v-card-title class="text--primary display-1">
              {{ title }}
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout >
        <v-flex xs12 sm6 d-flex>
          <v-card mt-0>
            <model-heading :keyCode="openDialog"/>
            <v-spacer/>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 d-flex>
          <v-card>
            <model-items :keyCode="openDialog"/>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

// import Model from '@/classes/Model.class'

// import ModelHeading from './ModelHeading'
// import ModelItems from './ModelItems'
// import ModelDisplay from './ModelDisplay'

export default {
  components: {
    // 'model-heading': ModelHeading,
    // 'model-items': ModelItems,
    // 'model-display': ModelDisplay
  },
  data: () => ({
    dialogEdit: true,
    keyCode: null
  }),

  created () {
    console.log('ModelEdit:created')
  },
  computed: {
    ...mapGetters({
      // getModelId: 'models/getModelId',
      model: 'models/model',
      asModel: 'models/asModel',
      getEditModel: 'models/getEditModel'
    }),
    title () {
      if (this.model.uuid.length === 0) {
        return 'Add a Model '
      } else {
        return 'Edit ' + this.model.portname
      }
    }
  },
  methods: {
    ...mapActions({
      startEditModel: 'models/startEditModel',
      addModel: 'models/addModel',
      updateModel: 'models/updateModel',
      setTabActive: 'nav/setTabActive'
    }),

    openDialog (event) {
      console.log('worked', event)
      var keyMessage = 'keyup: '
      if (event.shiftKey) {
        keyMessage += 'Shift+'
      } else if (event.altKey) {
        keyMessage += 'Alt+'
      }
      keyMessage += event.key || String.fromCharCode(event.keyCode)
      if (keyMessage === 'Alt+n') {
        console.log('send message for new position ')
        this.keyCode = keyMessage
      }
      return keyMessage
    }

    // moved to ModelHeading
    // formIsValid () {
    //   const port = this.getEditModel
    //   if (port !== null &&
    //     port !== undefined) {
    //     return port.portname !== '' &&
    //       port.description !== '' &&
    //       port.startDate !== '' &&
    //       //            this.rebalance !== '' &&
    //       port.status !== ''
    //   }
    // },
    //
    // submit () {
    //   if (this.formIsValid) {
    //     const id = this.getModelId
    //     if (id === null || id === undefined) {
    //       this.addModel(
    //         new Model(this.getEditModel).savedProperties()
    //       )
    //     } else {
    //       console.log('submit: ', this.getEditModel)
    //       console.log('submit: savedProperties', new Model(this.getEditModel).savedProperties())
    //       this.updateModel(
    //         new Model(this.getEditModel).savedProperties()
    //       )
    //     }
    //     this.dialogEdit = false
    //     this.setTabActive('0')
    //   }
    // },
    // cancel () {
    //   this.dialogEdit = false
    //   this.setTabActive('0')
    // }
  }
}
</script>
